<template>
<transition name="fade">
	<div class="loading" :style="{'border-radius':`${radius}rem`,'background-color':background,'position':position}">
		<div class="loading-center" :style="{width:`${size*5}rem`,height:`${size}rem`}">
			<div class="circle" 
                 :style="{width:`${size}rem`,height:`${size}rem`,'background-color':color}" 
                 v-for="index in 3" 
                 :key="index" ></div>
		</div>
	</div>
</transition>
</template>
<script>
export default {
    name: 'cSpin',
    props: {
        size: {
            type: Number,
            default: 0.1
        },
        radius: {
            type: Number,
            default: 0
        },
        color: {
            type: String,
            default: '#fff'
        },
        background: {
            type: String,
            default: 'rgba(0,0,0,0.6)'
        },
        position: {
            type: String,
            default: 'absolute'
        }
    }
};
</script>
<style lang='scss' scoped>
@import 'src/style/frequently.scss';
.loading {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;

    .loading-center {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -45%);
        display: flex;
        justify-content: space-around;
    }

    .circle {
        background-color: $impColor;
        float: left;
        animation: scale 1.5s infinite;
        border-radius: 50% 50% 50% 50%;
        &:nth-of-type(2) {
            animation-delay: 0.25s;
        }
        &:nth-of-type(3) {
            animation-delay: 0.5s;
        }
    }
}

@keyframes scale {
    75% {
        transform: scale(0);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/commons/cSpin.vue